import Vue from "vue"
import MentorCityComponent from "./MentorCityComponent.vue"

class MentorCityModule {

  static init() {
    Vue.component('mentor-city-component', MentorCityComponent)
  }

}

MentorCityModule.init()